var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useRef, useState, } from "react";
import { Alert, Box, Container, Divider, Grid, Snackbar, Tab, Tabs, Typography, } from "@mui/material";
import AssistentePainel from "../../components/ChatBot";
import { DashboardFilters, DashboardFiltersSkeleton, } from "../../components/dashboard/DashboardFilters";
import { DataSourceTooltip } from "../../components/DataSourceTooltip";
import { Disque100TabContent } from "../../domains/disque100/components/Disque100TabContent";
import { DISQUE100_FILTERABLE_TABS, DISQUE100_SUBTAB_ID_BY_TAB, } from "../../domains/disque100/config/tabs";
import { useHistory, useLocation } from "react-router-dom";
import { MulheresTabContent } from "../../domains/mulheres/components/MulheresTabContent";
import { useDisque100Filters } from "../../domains/disque100/hooks/useDisque100Filters";
import { useDashboardCatalog } from "../../shared/dashboard/hooks/useDashboardCatalog";
import { API_ENDPOINTS } from "../../lib/api/endpoints";
import { buildChartGridMdMap, buildCompactChartWidthOverrides, ChartCard, } from "./ChartCard";
import { LgbtqiaTab } from "./tabs/LgbtqiaTab";
import { DASHBOARD_ROUTES, LGBTQIA_YEAR_TO_PATH, MULHERES_SUBTAB_TO_PATH, } from "../../routes/dashboardRoutes";
import { ShareCurrentViewButton } from "../../shared/components/ShareCurrentViewButton";
import { useSessionStorage } from "../../hooks/Session";
export { buildChartGridMdMap, buildCompactChartWidthOverrides, buildCompactRunWidths, getChartGridMd, getChartFamilyType, } from "./ChartCard";
export { LGBTQIA_CARD_WIDTH_BY_YEAR } from "../../domains/lgbtqia/config/charts";
var MAX_CUSTOM_CHARTS = 6;
export var LGBTQIA_TAB = "lgbtqia";
export var MULHERES_TAB = "mulheres";
var DISQUE100_SOURCE_URL = "https://www.gov.br/mdh/pt-br/acesso-a-informacao/dados-abertos/disque100";
var TAB_ITEMS = [
    { label: "Denúncias", value: "/disque100/denuncias" },
    { label: "Denúncias (Vítimas)", value: "/disque100/vitimas" },
    { label: "Denúncias (Violações)", value: "/disque100/violacoes" },
    { label: "Denúncias (Outros)", value: "/disque100/outros" },
    { label: "Boletins LGBTQIA+", value: "/lgbtqia/2022" },
    { label: "Mulheres", value: "/mulheres/visao-geral" },
];
export var shouldRenderPainelToolbar = function (domain) {
    return domain === "disque100" || domain === 0;
};
var PainelPage = function () {
    var _a, _b;
    var history = useHistory();
    var location = useLocation();
    var _c = useState([]), customCharts = _c[0], setCustomCharts = _c[1];
    var _d = useState(false), isToastOpen = _d[0], setIsToastOpen = _d[1];
    var hasHydratedCustomCharts = useRef(false);
    var customChartsSessionRef = useRef(useSessionStorage("custom_charts"));
    var catalog = useDashboardCatalog().catalog;
    var _e = useDisque100Filters(), values = _e.values, handleFilterChange = _e.handleFilterChange, resetFilters = _e.resetFilters;
    var customChartsSession = customChartsSessionRef.current;
    var _f = location.pathname.split("/"), _g = _f[1], domain = _g === void 0 ? "disque100" : _g, _h = _f[2], subaba = _h === void 0 ? "denuncias" : _h;
    var isCustomTab = location.pathname === DASHBOARD_ROUTES.meusGraficos;
    var activeLgbtqiaYear = (domain === "lgbtqia" ? subaba : "2022");
    var activeMulheresSubTab = (domain === "mulheres" ? subaba : "visao-geral");
    useEffect(function () {
        if (hasHydratedCustomCharts.current)
            return;
        var storedCharts = customChartsSession.get();
        if (Array.isArray(storedCharts) && storedCharts.length > 0) {
            setCustomCharts(storedCharts);
        }
        hasHydratedCustomCharts.current = true;
    }, [customChartsSession]);
    useEffect(function () {
        if (!hasHydratedCustomCharts.current)
            return;
        if (customCharts.length > 0) {
            customChartsSession.set(customCharts);
            return;
        }
        customChartsSession.remove();
    }, [customCharts, customChartsSession]);
    var handleChartGenerated = useCallback(function (chart) {
        if (customCharts.some(function (existing) { return existing.normalizedQuery === chart.normalizedQuery; })) {
            return { accepted: false, reason: "duplicate" };
        }
        if (customCharts.length >= MAX_CUSTOM_CHARTS) {
            return { accepted: false, reason: "limit" };
        }
        setCustomCharts(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
            {
                title: chart.title,
                data: chart.data,
                query: chart.query,
                normalizedQuery: chart.normalizedQuery,
            },
        ], false); });
        history.push(DASHBOARD_ROUTES.meusGraficos);
        return { accepted: true };
    }, [customCharts, history]);
    var handleDeleteCustomChart = function (index) {
        setCustomCharts(function (prev) { return prev.filter(function (_, i) { return i !== index; }); });
    };
    var resolveTopTabValue = function (pathname) {
        if (pathname === DASHBOARD_ROUTES.meusGraficos) {
            return DASHBOARD_ROUTES.meusGraficos;
        }
        if (pathname.startsWith("/mulheres/"))
            return "/mulheres/visao-geral";
        if (pathname.startsWith("/lgbtqia/"))
            return "/lgbtqia/2022";
        return pathname;
    };
    var activeTabValue = resolveTopTabValue(location.pathname);
    var activeDisque100Tab = domain === "disque100"
        ? ((_a = { denuncias: 0, vitimas: 1, violacoes: 2, outros: 3 }[subaba]) !== null && _a !== void 0 ? _a : 0)
        : undefined;
    var activeDisque100Subtab = activeDisque100Tab != null
        ? (_b = catalog === null || catalog === void 0 ? void 0 : catalog.domains.find(function (section) { return section.id === "disque100"; })) === null || _b === void 0 ? void 0 : _b.sections.find(function (subtab) {
            return subtab.slug === DISQUE100_SUBTAB_ID_BY_TAB[activeDisque100Tab];
        })
        : undefined;
    var customChartsForTab = customCharts;
    var compactCustomChartWidthOverrides = buildCompactChartWidthOverrides(customChartsForTab);
    var customChartGridMdMap = buildChartGridMdMap(customChartsForTab);
    var visibleTabs = useMemo(function () { return __spreadArray(__spreadArray([], TAB_ITEMS, true), (customCharts.length > 0 || isCustomTab
        ? [{ label: "Meus Gráficos", value: DASHBOARD_ROUTES.meusGraficos }]
        : []), true); }, [customCharts.length, isCustomTab]);
    return (_jsxs(Box, __assign({ sx: { minHeight: "100vh", background: "#FFFFFF" } }, { children: [_jsxs(Container, __assign({ maxWidth: "xl", sx: { px: { xs: 2, md: 4 } } }, { children: [_jsx(Box, __assign({ sx: { pt: 4, pb: 1 } }, { children: _jsx(Typography, __assign({ sx: {
                                fontFamily: "Montserrat, sans-serif",
                                fontWeight: 800,
                                fontSize: { xs: "1.6rem", md: "2rem" },
                                color: "#111827",
                            } }, { children: "Observat\u00F3rio dos Direitos Humanos" })) })), _jsxs(Box, { children: [_jsx(Tabs, __assign({ value: activeTabValue, variant: "scrollable", scrollButtons: "auto", allowScrollButtonsMobile: true, onChange: function (_, value) {
                                    if (value === DASHBOARD_ROUTES.meusGraficos) {
                                        history.push(DASHBOARD_ROUTES.meusGraficos);
                                        return;
                                    }
                                    if (domain === "disque100" &&
                                        String(value).startsWith("/disque100/")) {
                                        history.push({
                                            pathname: String(value),
                                            search: location.search,
                                        });
                                    }
                                    else {
                                        history.push(String(value));
                                    }
                                }, sx: {
                                    mt: 1,
                                    "& .MuiTab-root": {
                                        textTransform: "none",
                                        fontFamily: "Montserrat, sans-serif",
                                        fontWeight: 500,
                                        fontSize: "0.9rem",
                                        color: "#6B7280",
                                        minWidth: "auto",
                                        px: 2,
                                        "&.Mui-selected": { color: "#034EA2", fontWeight: 700 },
                                    },
                                    "& .MuiTabs-indicator": {
                                        backgroundColor: "#034EA2",
                                        height: 2,
                                    },
                                } }, { children: visibleTabs.map(function (tab) { return (_jsx(Tab, { value: tab.value, label: tab.label }, tab.value)); }) })), _jsx(Divider, { sx: { borderColor: "#E5E7EB" } })] }), !isCustomTab && shouldRenderPainelToolbar(domain) && (_jsx(Box, __assign({ sx: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            mt: 2.5,
                            mb: 2.5,
                            gap: 2,
                            flexWrap: "wrap",
                        } }, { children: _jsxs(Box, __assign({ sx: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 2,
                                flexWrap: "wrap",
                                width: "100%",
                            } }, { children: [domain === "disque100" &&
                                    activeDisque100Tab != null &&
                                    DISQUE100_FILTERABLE_TABS.has(activeDisque100Tab) &&
                                    (activeDisque100Subtab ? (_jsx(DashboardFilters, { endpoint: API_ENDPOINTS.dashboardSubtabFilters("disque100", activeDisque100Subtab.slug), values: values, testIdPrefix: "disque100-filter", onChange: handleFilterChange, onClear: resetFilters })) : (_jsx(DashboardFiltersSkeleton, { count: 2, labels: ["Ano", "Semestre"] }))), _jsx(Box, __assign({ sx: { ml: domain === "disque100" ? "auto" : 0 } }, { children: _jsxs(Box, __assign({ sx: { display: "flex", gap: 1, alignItems: "center" } }, { children: [domain === "disque100" && (_jsx(DataSourceTooltip, { base: "Disque 100 / MDH", description: "Os dados desta se\u00E7\u00E3o s\u00E3o obtidos a partir da base Disque 100, disponibilizada pelo Minist\u00E9rio dos Direitos Humanos e da Cidadania.", link: DISQUE100_SOURCE_URL })), domain === "disque100" && (_jsx(ShareCurrentViewButton, { onCopied: function () { return setIsToastOpen(true); } }))] })) }))] })) }))), isCustomTab ? (_jsx(_Fragment, { children: customChartsForTab.length > 0 ? (_jsx(Grid, __assign({ container: true, spacing: 2.5 }, { children: customChartsForTab.map(function (chart, index) {
                                var _a, _b;
                                var compactWidthOverride = compactCustomChartWidthOverrides[index];
                                var gridMd = (_b = (_a = customChartGridMdMap[index]) !== null && _a !== void 0 ? _a : compactWidthOverride) !== null && _b !== void 0 ? _b : 6;
                                return (_jsx(Grid, __assign({ item: true, xs: 12, md: gridMd }, { children: _jsx(ChartCard, { chart: chart, onDownloadToast: function () { return setIsToastOpen(true); }, onDelete: function () { return handleDeleteCustomChart(index); } }) }), "".concat(activeTabValue, "-").concat(index, "-").concat(chart.title)));
                            }) }))) : (_jsx(Box, __assign({ sx: {
                                minHeight: 220,
                                borderRadius: "14px",
                                border: "1px dashed #D1D5DB",
                                background: "#F9FAFB",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                px: 3,
                            } }, { children: _jsx(Typography, __assign({ sx: {
                                    fontFamily: "Montserrat, sans-serif",
                                    fontSize: "0.9rem",
                                    color: "#4B5563",
                                    textAlign: "center",
                                } }, { children: "Nenhum gr\u00E1fico personalizado foi criado nesta sess\u00E3o." })) }))) })) : domain === "lgbtqia" ? (_jsx(LgbtqiaTab, { year: activeLgbtqiaYear, onYearChange: function (year) { return history.push(LGBTQIA_YEAR_TO_PATH[year]); }, onDownloadToast: function () { return setIsToastOpen(true); }, onShareCopied: function () { return setIsToastOpen(true); } })) : domain === "mulheres" ? (_jsx(MulheresTabContent, { activeSubTab: activeMulheresSubTab, onSubTabChange: function (subtab) {
                            return history.push(MULHERES_SUBTAB_TO_PATH[subtab]);
                        }, onShareCopied: function () { return setIsToastOpen(true); } })) : domain === "disque100" && activeDisque100Tab != null ? (_jsx(Disque100TabContent, { activeTab: activeDisque100Tab, dynamicSubtab: activeDisque100Subtab, onDownloadToast: function () { return setIsToastOpen(true); } })) : null, _jsx(Box, { sx: { pb: 10 } })] })), _jsx(AssistentePainel, { onChartGenerated: handleChartGenerated }), _jsx(Snackbar, __assign({ open: isToastOpen, autoHideDuration: 3500, onClose: function () { return setIsToastOpen(false); }, anchorOrigin: { vertical: "bottom", horizontal: "center" } }, { children: _jsx(Alert, __assign({ onClose: function () { return setIsToastOpen(false); }, severity: "info", variant: "filled", sx: { fontFamily: "Montserrat, sans-serif", fontSize: "0.85rem" } }, { children: "Link copiado com filtros aplicados." })) }))] })));
};
export default PainelPage;
